
















































































































































































































































































































































































































































import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import TaskFilterPeriod from '@/components/taskList/taskFilterParts/TaskFilterPeriod.vue';
import AccountIcon from '@/components/common/AccountIcon.vue';
import { TaskSortParams, Representative } from '@/@types/LibraryComponent';
import { FindTasksQuery } from '@/@types/Task';
import { vxm } from '@/store';

@Component({
  components: {
    TaskFilterPeriod,
    AccountIcon,
  },
})
export default class TaskFilter extends Vue {
  @Prop()
  private representatives!: Representative[];
  private isAll: boolean = true;
  private isOwn: boolean = false;
  private isFilterOpen: boolean = false;
  private searchInputCurrentResponsiblePerson = null;
  private searchInputPractitioner = null;
  private searchInputRegistrationPerson = null;
  private currentResponsiblePersons: string[] = [];
  private practitioners: string[] = [];
  private registrationPersons: string[] = [];
  /** 以下、クエリパラメータに対応するプロパティ */
  private categoryAll: boolean = false;
  private consideration: boolean = false;
  private task: boolean = false;
  private research: boolean = false;
  private statusAll: boolean = false;
  private unsupported: boolean = false;
  private processing: boolean = false;
  private processed: boolean = false;
  private saving: boolean = false;
  private completed: boolean = false;
  private priorityAll: boolean = false;
  private high: boolean = false;
  private middle: boolean = false;
  private low: boolean = false;
  private ownTask: boolean = false;
  private allTask: boolean = true;
  private currentResponsiblePersonIds: number[] = [];
  private practitionerIds: number[] = [];
  private registrationPersonIds: number[] = [];
  private keyword: string = '';
  private dateQuery: Omit<FindTasksQuery, 'project-id'> = {};
  private removeFilterChip(item: Representative, charge: string) {
    switch (charge) {
      case '担当者':
        const currentResponsiblePersonsIndex = this.currentResponsiblePersonIds.indexOf(item.accountId);
        this.currentResponsiblePersonIds.splice(currentResponsiblePersonsIndex, 1);
        break;
      case '受託者':
        const practitionersIndex = this.practitionerIds.indexOf(item.accountId);
        this.practitionerIds.splice(practitionersIndex, 1);
        break;
      case '登録者':
        const registrationPersonsIndex = this.registrationPersonIds.indexOf(item.accountId);
        this.registrationPersonIds.splice(registrationPersonsIndex, 1);
        break;
    }
    this.emitSortQuery();
  }

  private textFlag(flag: boolean): boolean {
    return !flag;
  }

  private onChangeIsFilterOpen(): void {
    this.isFilterOpen = !this.isFilterOpen;
    return;
  }
  private onCloseFilter(): void {
    this.isFilterOpen = false;
    return;
  }

  private onChangeFilterIsAll(): void {
    this.isAll = true;
    this.isOwn = false;
    this.allTask = true;
    this.ownTask = false;
    this.emitSortQuery();
  }

  private onChangeFilterIsOwn(): void {
    this.isOwn = true;
    this.isAll = false;
    this.allTask = false;
    this.ownTask = true;
    this.emitSortQuery();
  }

  private assignDateQuery(queryObject: Omit<FindTasksQuery, 'project-id'>) {
    this.dateQuery = queryObject;
    this.emitSortQuery();
  }

  private get allTaskCount() {
    const tasks = vxm.theoryApi.tasksStore.getTasks;
    return tasks ? tasks.results.length : 0;
  }

  private get myTaskCount() {
    const tasks = vxm.theoryApi.tasksStore.getTasks;
    if (tasks) {
      return tasks.results.filter((task) => {
        return task.currentResponsiblePersonId === this.accountId;
      }).length;
    } else return 0;
  }

  private get classIsFilterShadow(): {
    'shadow-open': boolean;
    'shadow-close': boolean;
  } {
    return {
      'shadow-open': this.isFilterOpen,
      'shadow-close': !this.isFilterOpen,
    };
  }

  private get classIsFontWeightBoldInAll(): {
    'font-weight-bold': boolean;
  } {
    return {
      'font-weight-bold': this.isAll,
    };
  }

  private get classIsFontWeightBoldInOwn(): {
    'font-weight-bold': boolean;
  } {
    return {
      'font-weight-bold': this.isOwn,
    };
  }

  private get accountId() {
    const response = vxm.theoryApi.authStore.getCurrentUserInfo;
    if (response) {
      return response.results.accountId;
    } else return null;
  }

  private get projectId() {
    return vxm.theoryApi.authStore.getCurrentProjectId;
  }

  /** ソート用のクエリパラメータを作成してemitする */
  @Emit('emitSortQuery')
  private emitSortQuery(): FindTasksQuery {
    let sortQuery: FindTasksQuery = {
      'project-id': this.projectId,
    };
    /** カテゴリー */
    if (this.categoryAll) {
      sortQuery.categories = [];
      sortQuery.categories = sortQuery.categories.concat(TaskSortParams.allCategory);
    } else {
      if (this.consideration || this.task || this.research) {
        sortQuery.categories = [];
        if (this.consideration) {
          sortQuery.categories.push(TaskSortParams.considerationCategory);
        }
        if (this.task) {
          sortQuery.categories.push(TaskSortParams.taskCategory);
        }
        if (this.research) {
          sortQuery.categories.push(TaskSortParams.researchCategory);
        }
      } else {
        delete sortQuery.categories;
      }
    }
    /** ステータス */
    if (this.statusAll) {
      sortQuery.statuses = [];
      sortQuery.statuses = sortQuery.statuses.concat(TaskSortParams.allStatus);
    } else {
      if (
        this.unsupported
          || this.processing
          || this.processed
          || this.saving
          || this.completed
        ) {
        sortQuery.statuses = [];
        if (this.unsupported) {
          sortQuery.statuses.push(TaskSortParams.unsupportedStatus);
        }
        if (this.processing) {
          sortQuery.statuses.push(TaskSortParams.processingStatus);
        }
        if (this.processed) {
          sortQuery.statuses.push(TaskSortParams.processedStatus);
        }
        if (this.saving) {
          sortQuery.statuses.push(TaskSortParams.savingStatus);
        }
        if (this.completed) {
          sortQuery.statuses.push(TaskSortParams.completedStatus)
        }
      } else {
        delete sortQuery.statuses;
      }
    }
    /** 優先度 */
    if (this.priorityAll) {
      sortQuery.priorities = [];
      sortQuery.priorities = sortQuery.priorities.concat(TaskSortParams.allPriority);
    } else {
      if (this.high || this.middle || this.low) {
        sortQuery.priorities = [];
        if (this.high) {
          sortQuery.priorities.push(TaskSortParams.highPriority);
        }
        if (this.middle) {
          sortQuery.priorities.push(TaskSortParams.middlePriority);
        }
        if (this.low) {
          sortQuery.priorities.push(TaskSortParams.lowPriority);
        }
      } else {
        delete sortQuery.priorities;
      }
    }
    /** 担当者 */
    if (this.allTask) {
      if (this.currentResponsiblePersonIds.length > 0) {
        if (!sortQuery['current-responsible-people']) {
          sortQuery['current-responsible-people'] = [];
        }
        sortQuery['current-responsible-people'] =
          sortQuery['current-responsible-people']
          .concat(this.currentResponsiblePersonIds);
      } else {
        delete sortQuery['current-responsible-people'];
      }
    }
    if (this.ownTask) {
      if (!sortQuery['current-responsible-people']) {
        sortQuery['current-responsible-people'] = [];
      }
      sortQuery['current-responsible-people'].push(this.accountId as number);
    }
    /** 作業実施者 */
    if (this.practitionerIds.length > 0) {
      if (!sortQuery.practitioners) {
        sortQuery.practitioners = [];
      }
      sortQuery.practitioners =
        sortQuery.practitioners.concat(this.practitionerIds);
    } else {
      delete sortQuery.practitioners;
    }
    /** 登録者 */
    if (this.registrationPersonIds.length > 0) {
      if (!sortQuery['registration-people']) {
        sortQuery['registration-people'] = [];
      }
      sortQuery['registration-people'] =
        sortQuery['registration-people'].concat(this.registrationPersonIds);
    } else {
      delete sortQuery['registration-people'];
    }
    /** キーワード */
    if (this.keyword) {
      sortQuery.keyword = this.keyword;
    } else {
      delete sortQuery.keyword;
    }
    /** 期限日・開始日・登録日・更新日 */
    sortQuery = { ...sortQuery, ...this.dateQuery };

    return sortQuery;
  }
}
